<template>
  <div class="footer_warp">
    <div class="footer flex">
      <div class="footer_info flex">
        <p>
          <span>
            Copyright@2022 宝鸡市扶风县图书馆版权所有
          </span>
          <span>
            网站访问量：921
          </span>
        </p>
        <p>
          技术支持：西安鼎浩科技有限公司
        </p>
      </div>
      <img
        class="footer_icon"
        src="@/assets/img/common/dinghao_icon.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.footer_warp {
  width: 100%;
  height: 85px;
  background: #d7e0e9;
  letter-spacing: 2px;
  .footer {
    height: 100%;
    font-size: 14px;
    color: #666;
    p {
      margin: 8px 0;
    }
    span {
      margin-right: 30px;
    }
  }
  .footer_info {
    flex-direction: column;
    margin-right: 80px;
  }
}
</style>
